var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"numbers"},on:{"click":_vm.closeNav}},[_c('dama-by-numbers',{attrs:{"cards":_vm.cards}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }